import classNames from "classnames";
import styles from "./style.module.scss";
import CustomCheckbox from "../common/customCheckbox";

interface PermissionCardProps {
  selected: boolean;
  title: string;
  description: string;
  onSelect: () => void;
  hasError?: boolean;
  children?: React.ReactNode;
}

const PermissionCard = ({
  selected,
  title,
  description,
  onSelect,
  hasError = false,
  children,
}: PermissionCardProps) => {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={(e) => e.key === "Enter" && onSelect()}
      className={classNames(
        styles.viewOnly,
        selected && styles.activeViewOnly,
        hasError && styles.error,
      )}
    >
      <div className={classNames(styles.item, "flex items-start gap-2")}>
        <div onClick={(e) => e.stopPropagation()}>
          <CustomCheckbox
            name={`role-${title.toLowerCase().replace(/\s+/g, "-")}`}
            checked={selected}
            onChange={onSelect}
            label=""
          />
        </div>

        <div className="flex flex-col gap-1">
          <h6>{title}</h6>
          <p className={styles.comment}>{description}</p>
          {children && (
            <div
              className={styles.cardExtra}
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
            >
              {children}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PermissionCard;
